<template>
  <div ref="reportHTML" v-html="pageHtml"></div>
</template>
<script>
export default {
  name: "AlipayH5",
  data() {
    return {
      pageHtml: "",
    };
  },
  created() {
    this.$log.debug("route->", this.$route);
    let params = this.$route.params;
    let srcHtml = params.pageHtml;
    this.$log.debug("srcHtml->", srcHtml);
    this.pageHtml = params.pageHtml;
    let jsscript = "";
    // 使用正则获取js内容
    let self = this;
    srcHtml.replace(/<script.*?>([\s\S]+?)<\/script>/gim, function (_, js) {
      //正则匹配出script中的内容
      jsscript = js;
      self.$log.debug("jsscript->", jsscript);
    });
    // 这里需要使用$nextTick  需要等dom更新后才能操作reportHTML
    this.$nextTick(() => {
      // 将js脚本内容插入到标签当中
      var newElement = document.createElement("script");
      newElement.innerHTML = jsscript;
      this.$refs.reportHTML.append(newElement);
      this.$log.debug("reportHTML->", this.$refs.reportHTML.innerHTML);
    });
  },
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/hongcheng/AlipayH5_hongcheng.vue